import React from "react";

interface AppLogoInterface {
  color?: string;
}

const AppLogo: React.FC<AppLogoInterface> = (props) => {
  return (
    <h3 className={`app-name ${props?.color ? 'primary-login-app-name' : 'login-app-name'}`}>
      <a href="https://missingskincare.com/" target="_self" rel="noreferrer">
        MISSING SKINCARE
      </a>
    </h3>
  );
};

export default AppLogo;
